<app-card-form [card]="card$ | async" (change)="update($event)" class="m-4"></app-card-form>
<div class="buttons m-4">
    <button mat-button (click)="cancel()" i18n>CANCEL</button>
    <button mat-button (click)="save()" i18n>SAVE</button>
</div>
